import { configureStore } from "@reduxjs/toolkit";
import { createSubmitFeedbackSlice } from "./submit_feedback_slice";

export const submitFeedbackSlice = createSubmitFeedbackSlice();
export const submitFeedbackActions = submitFeedbackSlice.actions;

export const submitFeedbackStore = configureStore({
    reducer: {
        submitFeedback: submitFeedbackSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        thunk: {
            extraArgument: {
                // userRepository,
                // tierRepository
            }
        }
    })
});